import React, { useState } from "react";
import { Link } from "react-router-dom";

const AccountModal = ({ open, onClose }) => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Non active pour l'instant - seuls l'apercu et le design sont en place.
  };

  if (!open) return null;

  return (
    <div className="gw-modal-overlay" onClick={onClose}>
      <div className="gw-modal" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="gw-modal-close" onClick={onClose} aria-label="Fermer">
          &times;
        </button>

        <div className="gw-modal-head">
          <div className="gw-modal-avatar">
            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-user">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
              <circle cx={12} cy={7} r={4} />
            </svg>
          </div>
          <h2 className="gw-modal-title">Mon compte</h2>
          <p className="gw-modal-subtitle">Connectez-vous pour suivre vos commandes et vos favoris.</p>
        </div>

        <form onSubmit={handleSubmit} className="gw-modal-form">
          <div className="gw-field">
            <label className="gw-field-label" htmlFor="account-email">Email</label>
            <input
              id="account-email"
              type="email"
              name="email"
              className="gw-field-input"
              placeholder="votre@email.com"
              value={form.email}
              onChange={handleChange}
            />
          </div>

          <div className="gw-field">
            <div className="gw-field-label-row">
              <label className="gw-field-label" htmlFor="account-password">Mot de passe</label>
              <Link to="/MyAccountForgetPassword" className="gw-forgot" onClick={onClose}>
                Mot de passe oublié
              </Link>
            </div>
            <div className="gw-password-wrap">
              <input
                id="account-password"
                type={showPassword ? "text" : "password"}
                name="password"
                className="gw-field-input"
                placeholder="••••••••"
                value={form.password}
                onChange={handleChange}
              />
              <button
                type="button"
                className="gw-eye"
                onClick={() => setShowPassword(!showPassword)}
                aria-label="Afficher le mot de passe"
              >
                {showPassword ? "🙈" : "👁️"}
              </button>
            </div>
          </div>

          <button type="submit" className="gw-btn gw-btn-primary gw-btn-block">
            Me connecter
          </button>

          <div className="gw-divider">
            <span>ou</span>
          </div>

          <button type="button" className="gw-btn gw-btn-outline gw-btn-block">
            Créer un compte
          </button>

          <p className="gw-modal-note">Votre espace client arrive très bientôt.</p>

          <div className="gw-admin-access">
            <span className="gw-admin-line" />
            <Link to="/MyAccountSignIn" className="gw-admin-link" onClick={onClose}>
              Accès administrateur
            </Link>
            <span className="gw-admin-line" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AccountModal;
